import { UserKind } from 'common/enums/user-kind.enum';
import { Gender } from 'common/enums/gender.enum';
import { boolean, object, string } from 'yup';
import { JobStatus } from 'common/enums/job-status.enum';
import { TypeOfTeaching } from 'common/enums/type-of-teaching.enum';
import { StudyLevel } from 'common/enums/study-level.enum';
import { ProfessionalSituation } from 'common/enums/professional-situation.enum';
import { EducationFunction } from 'common/enums/education-function.enum';
import { UnemployedLength } from 'common/enums/unemployed-length.enum';
import { Nationality } from 'common/enums/nationality.enum';
import './utils/email';

function conditionalField(value: object, is: UserKind, response: string) {
  return string()
    .notRequired()
    .oneOf(Object.values(value))
    .when('kind', {
      is,
      then(schema) {
        return schema.required(response);
      },
    });
}
export const formsProfileValidation = object().shape({
  kind: string().oneOf(Object.values(UserKind)),
  newsAgreement: boolean(),
  applicant: object().when('kind', {
    is: UserKind.Company,
    then: () =>
      object().shape({
        firstName: string().required('validations.first_name.required'),
        lastName: string().required('validations.last_name.required'),
        email: string()
          .email('validations.email.format')
          .required('validations.email.required'),
        phone: string().matches(/^(\+3[1-9])\s?\d{8,9}$/, {
          message: 'validations.phone.format',
          excludeEmptyString: true,
        }),
        companyNumber: string().notRequired(),
        companyName: string().required('validations.company_name.required'),
      }),
    otherwise: () =>
      object().shape({
        firstName: string().required('validations.first_name.required'),
        phone: string().required('validations.phone.required'),
        email: string()
          .email('validations.email.format')
          .required('validations.email.required'),
        lastName: string().required('validations.last_name.required'),
      }),
  }),
  address: object().shape({
    streetAndNumber: string().required('validations.address.street_and_number'),
    town: string().required('validations.address.town'),
    zip: string().required('validations.address.zip'),
  }),
  billingAddress: object().when('isBillingAddress', {
    is: true,
    then: () =>
      object().shape({
        streetAndNumber: string().required(
          'validations.address.street_and_number'
        ),
        town: string().required('validations.address.town'),
        zip: string().required('validations.address.zip'),
      }),
  }),
  gender: string()
    .oneOf(Object.values(Gender))
    .required('validations.gender.required'),
  unemployedLength: conditionalField(
    UnemployedLength,
    UserKind.Unemployed,
    'validations.unemployed_length.required'
  ),
  nationality: conditionalField(
    Nationality,
    UserKind.Unemployed,
    'validations.nationality.required'
  ),
  studyLevel: conditionalField(
    StudyLevel,
    UserKind.Unemployed,
    'validations.study_level.required'
  ),
  professionalSituation: conditionalField(
    ProfessionalSituation,
    UserKind.Unemployed,
    'validations.professional_situation.required'
  ),
  educationFunction: conditionalField(
    EducationFunction,
    UserKind.Teacher,
    'validations.education_function.required'
  ),
  typeOfTeaching: conditionalField(
    TypeOfTeaching,
    UserKind.Teacher,
    'validations.type_of_teaching.required'
  ),
  jobStatus: conditionalField(
    JobStatus,
    UserKind.Company,
    'validations.job_status.required'
  ),
});
